/**
 * What the review window's chat pane does when an item opens.
 *
 * The window opens straight onto the conversation: there is no cover to click
 * through (operator decision 2026-10-21). The pane asks once per
 * conversation, and stepping to another item on the same conversation keeps
 * it. Every item in the viewer's scope opens (item 95: the tab does not read
 * `insights.transcripts`).
 */

export type ChatPaneStep = 'wait' | 'keep' | 'load';

export interface ChatPaneItem {
  conversation_id: string | null;
}

export function chatPaneStep(item: ChatPaneItem | null, shownConversationId: string | null): ChatPaneStep {
  if (!item || !item.conversation_id) return 'wait';
  if (shownConversationId && shownConversationId === item.conversation_id) return 'keep';
  return 'load';
}

/** The key of one ask: the conversation, from the feedback it was opened at.
 *  The same key twice (React's development double run, the list item replaced
 *  by its fetched record) is one ask — one fetch, not two. */
export function askKey(conversationId: string | null, feedbackId: string | null): string | null {
  return conversationId ? `${conversationId}:${feedbackId ?? ''}` : null;
}
